<template>
  <div class="face" v-if="isHumanReview">
    <div class="faceBack"></div>
    <div class="faceDataDlo">
      <div class="titleDialog">
        <p>人脸识别</p>
        <i></i>
        <!--        <em  class="el-icon-close detIcon" @click="isOpenShow()"></em>-->
      </div>
      <div class="faceDiv" v-if="isSuccessful === ''">
        <p>请衣着整齐，对准摄像头，并正对光源</p>
        <div class="faceData">
          <div class="leftTop"></div>
          <div class="rightTop"></div>
          <div class="leftButton"></div>
          <div class="rightButton"></div>
          <i class="faceDataLine"></i>
          <video
            autoplay
            playsinline
            id="video"
            width="300"
            height="300"
          ></video>
          <canvas id="canvas" width="300" height="300"></canvas>
          <div class="faceNumber" v-if="countNum > 0">{{ countNum }}</div>
        </div>
        <el-button class="refer-btn" type="primary">人脸识别中...</el-button>
      </div>

      <!--      审核中-->
      <div class="faceDivSuccessful" v-if="isSuccessful === 'audit'">
        <img class="auditImg" src="../assets/images/auditImg.png" alt="" />
        <p>正在识别中请耐心等待...</p>
      </div>
      <!--      成功-->
      <div class="faceDivSuccessful" v-if="isSuccessful === 'successful'">
        <img src="../assets/images/faceSuccessful.png" alt="" />
        <p>
          已识别成功<br />点击下方按钮去{{
            isTest ? (equipment ? "继续操作" : "继续考试") : "继续观看"
          }}
        </p>
        <el-button class="refer-btn" type="primary" @click="isRouter()">{{
          isTest ? (equipment ? "确定" : "继续考试") : "继续观看"
        }}</el-button>
      </div>
      <!--      失败-->
      <div class="faceDivSuccessful" v-if="isSuccessful === 'failure'">
        <img src="../assets/images/faceErr.png" alt="" />
        <p>{{ msgData }}<br />请拨打下方电话，联系管理员<br />023-62652911,023-62652917</p>
        <el-button class="refer-btn" type="primary" @click="setSuccessful()"
          >重新识别</el-button
        >
        <!--        <el-button style="margin-top: 10px;background-color: #c0c0c0;border-color: #c0c0c0" class="refer-btn isReturn" type="primary" @click="setSuccessful()">重新识别</el-button>-->
      </div>

      <div class="faceDivSuccessful" v-if="isSuccessful === 'equipment'">
        <img src="../assets/images/faceErr.png" alt="" />
        <strong>浏览器未检测到摄像头</strong>
        <p>1、请确认是否安装可使用的摄像头</p>
        <p class="pButton">2、请确认浏览器是否设置允许本网站调用摄像头</p>
        <el-button class="refer-btn" type="primary" @click="$router.go(-1)"
          >确定</el-button
        >
      </div>
    </div>
  </div>
</template>

<script>
import { putObjectBlob } from "@/utils/upload";

require("tracking/build/tracking-min.js");
require("tracking/build/data/face-min.js");
import { faceServe } from "@/api/home";
import { getStore } from "@/utils/localStorage";
export default {
  name: "face",
  props: {
    isTest: {
      type: Boolean,
      default: false,
    },
    equipment: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      trackerTask: null,
      mediaStreamTrack: null,
      start: true,
      isSuccessful: "",
      isTime: "",
      isHumanReview: true,
      count: 0,
      countNum: 3,
      msgData: "",
    };
  },

  mounted() {
    this.openUserMedia();
    setTimeout(() => {
      this.openCamera();
    }, 3000);
  },
  methods: {
    sportsCamera() {
      this.mediaStreamTrack.getTracks()[0].stop();
      this.mediaStreamTrack = null;
    },
    isRouter() {
      this.$emit("isRouter");
    },
    setTimeNum() {
      this.countNum = 3;
      const times = setInterval(() => {
        this.countNum -= 1;
        if (this.countNum === 0) {
          clearInterval(times);
        }
      }, 1000);
    },
    setSuccessful() {
      this.isSuccessful = "";
      this.start = true;
      setTimeout(() => {
        this.openUserMedia();
        setTimeout(() => {
          this.openCamera();
        }, 3000);
      }, 1000);
    },
    success(stream) {
      const than = this;
      let video = document.getElementById("video");
      than.mediaStreamTrack = null;
      than.mediaStreamTrack = stream;
      try {
        video.srcObject = stream;
      } catch (e) {
        console.log("访问用户媒体设备失败：", e.name, e.message);
      }
      video.play(); //播放视频
    },
    error(error) {
      this.isSuccessful = "equipment";
      console.log("访问用户媒体失败：", error.name, error.message);
    },
    getUserMediaToPhoto(constraints, success, error) {
      if (navigator.mediaDevices.getUserMedia) {
        navigator.mediaDevices
          .getUserMedia(constraints)
          .then(success)
          .catch(error);
      } else if (navigator.webkitGetUserMedia) {
        navigator.webkitGetUserMedia(constraints, success, error);
      } else if (navigator.mozGetUserMedia) {
        navigator.mozGetUserMedia(constraints, success, error);
      } else if (navigator.getUserMedia) {
        navigator.getUserMedia(constraints, success, error);
      }
    },
    openCamera() {
      const than = this;
      let tracker = new window.tracking.ObjectTracker("face");
      tracker.setInitialScale(4);
      tracker.setStepSize(2);
      tracker.setEdgesDensity(0.1);
      than.trackerTask = tracking.track("#video", tracker, { camera: true });
      tracker.on("track", (event) => {
        if (event.data.length > 0) {
          event.data.forEach(() => {
            if (than.start) {
              this.start = false;
              setTimeout(() => {
                this.isSuccessful = "audit";
                than.isOpen();
              }, 5000);
            }
          });
        }
      });
    },
    openUserMedia() {
      this.setTimeNum();
      if (
        navigator.mediaDevices.getUserMedia ||
        navigator.webkitGetUserMedia ||
        navigator.mozGetUserMedia ||
        navigator.getUserMedia
      ) {
        this.getUserMediaToPhoto(
          {
            video: {
              width: 300,
              height: 300,
              facingMode: "user",
            },
          },
          this.success,
          this.error
        );
      } else {
        alert("你的浏览器不支持访问用户媒体设备");
      }
    },
    isOpen() {
      this.count += 1;
      let video = document.getElementById("video"),
        canvas = document.getElementById("canvas");
      let ipDataNull = {
        isPerson: false,
        pcFacility: "",
        studentUuid: JSON.parse(getStore("userInfo")).commonUuid,
      };
      // vendorUrl = window.URL || window.webkitURL;
      navigator.getMedia =
        navigator.mediaDevices.getUserMedia ||
        navagator.webkitGetUserMedia ||
        navigator.mozGetUserMedia ||
        navigator.msGetUserMedia;
      navigator.getMedia(
        {
          video: true, //使用摄像头对象
          audio: false, //不适用音频
        },
        function () {
          // video.src = (vendorUrl).createObjectURL(this.mediaStreamTrack);
          video.play();
        },
        function (error) {
          //error.code
          console.log(error);
        }
      );
      canvas.getContext("2d").drawImage(video, 0, 0, 300, 300);
      const imgData = canvas.toDataURL("image/png");

      let file = this.dataURLtoFile(imgData, "image/png");
      putObjectBlob(file, async (res) => {
        const { data } = await faceServe.userSearch({
          url: res,
        });

        if (!data.result) {
          // console.log("识别失败", data);
          if (this.count === 3) {
            this.sportsCamera();
            if (this.isTest) {
              this.$emit("forcedSubmit");
              if (this.equipment) await faceServe.updateRecords(ipDataNull);
              return;
            }
            this.$emit("isFailure");
            return;
          }
          this.isSuccessful = "failure";
          this.msgData = data.msg;
          // this.$message.error(this.msgData);
        } else {
          // console.log("识别成功", data);
          this.isSuccessful = "successful";
          if (this.equipment) {
            ipDataNull.isPerson = true;
            ipDataNull.pcFacility = getStore("ipData");
          }
        }
        // if(this.equipment) await faceServe.updateRecords(ipDataNull);
        this.sportsCamera();
        clearInterval(this.isTime);
        this.trackerTask.stop();
      });
    },
    dataURLtoFile(dataURI, type) {
      let binary = atob(dataURI.split(",")[1]);
      let array = [];
      for (let i = 0; i < binary.length; i++) {
        array.push(binary.charCodeAt(i));
      }
      return new Blob([new Uint8Array(array)], { type: type });
    },
  },
};
</script>

<style scoped lang="scss">
.face {
  width: 100%;
  height: 100%;
  position: fixed;
  left: 0;
  top: 0;
  z-index: 111;
  display: flex;
  justify-content: center;
  align-items: center;
  background: rgba(0, 0, 0, 0.5);
}
.face .faceDataDlo {
  width: 665px;
  background: #fff;
  padding: 30px 0;
  // height: 600px;
  // margin-top: 10%;
}
.titleDialog {
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;
}
.titleDialog p {
  font-size: 20px;
  color: #333;
}
.titleDialog i {
  width: 105px;
  height: 13px;
  @include bgColor("primary");
  margin-top: -12px;
  opacity: 0.37;
}
.faceDiv {
  display: flex;
  flex-direction: column;
  align-items: center;
}
.faceDiv p {
  font-size: 15px;
  color: #333;
  margin: 50px 0 42px;
}
.faceDiv .faceData {
  width: 300px;
  height: 300px;
  overflow: hidden;
  position: relative;
  margin-bottom: 50px;
}
.faceDiv .faceData .faceNumber {
  width: 300px;
  height: 300px;
  background: rgba(0, 0, 0, 0.3);
  position: absolute;
  left: 0;
  top: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 80px;
  font-weight: bold;
  color: #fff;
}

.faceDiv .leftTop {
  width: 50px;
  height: 50px;
  border-left: 10px solid #2e58ff;
  border-top: 10px solid #2e58ff;
  position: absolute;
  left: 0;
  top: 0;
}
.faceDiv .rightTop {
  width: 50px;
  height: 50px;
  border-right: 10px solid #2e58ff;
  border-top: 10px solid #2e58ff;
  position: absolute;
  right: 0;
  top: 0;
}
.faceDiv .leftButton {
  width: 50px;
  height: 50px;
  border-left: 10px solid #2e58ff;
  border-bottom: 10px solid #2e58ff;
  position: absolute;
  left: 0;
  bottom: 0;
}
.faceDiv .rightButton {
  width: 50px;
  height: 50px;
  border-right: 10px solid #2e58ff;
  border-bottom: 10px solid #2e58ff;
  position: absolute;
  right: 0;
  bottom: 0;
}
.faceDiv .faceDataLine {
  width: 300px;
  height: 2px;
  background: #2e58ff;
  position: absolute;
  top: 0;
  animation: keyLine 1.5s infinite;
}
.faceDivSuccessful {
  display: flex;
  flex-direction: column;
  align-items: center;
}
.faceDivSuccessful strong {
  margin-bottom: 20px;
  font-size: 15px;
  color: #333;
}
.faceDivSuccessful p {
  font-size: 14px;
  color: #999;
}
.faceDivSuccessful .pButton {
  margin: 5px 0 30px;
}
.faceDivSuccessful img {
  margin: 55px 0 25px;
}
.faceDivSuccessful .auditImg {
  margin: 150px 0 25px;
}
.refer-btn {
  width: 233px;
  border-radius: 50px;
}
.isReturn:hover {
  opacity: 0.7;
}
.detIcon {
  font-size: 30px;
  position: absolute;
  top: 10px;
  right: 10px;
  cursor: pointer;
}
.detIcon:hover {
  color: #2e58ff;
}
@keyframes keyLine {
  0% {
    top: 0;
  }
  50% {
    top: 300px;
  }
  100% {
    top: 0;
  }
}
</style>
